export default __webpack_public_path__ + "static/media/black-arrow-gif.1c846999.gif";